import classNames from "classnames";
import React from "react";
import { TooltipComponent } from "../tooltipComponent";
import styles from "./form.css";

interface Props extends React.HTMLProps<HTMLTextAreaElement> {
  hasError?: boolean;
  errorHint?: string;
}

export const EditTextarea: React.SFC<Props> = ({
  hasError,
  errorHint,
  className,
  ...textareaProps
}) => (
  <div
    className={classNames(styles["textarea-container"], className, {
      [styles["has-error"]]: hasError
    })}
  >
    <div className={styles["ghost-input"]}>{textareaProps.value || ""}</div>
    <textarea {...textareaProps} rows={1} />
    {hasError && errorHint && (
      <i className={["icon-exclamation-mark", styles["error-feedback"]].join(" ")}>
        <TooltipComponent
          positionPreset={"top"}
          text={errorHint}
          width={"80px"}
          maxWidth={"80px"}
          style={"error"}
          changeTransformTooltip={"translateX(-80%)"}
          changeTransformOutset={"translateX(300%)"}
        >
          <div />
        </TooltipComponent>
      </i>
    )}
  </div>
);
